export const ADDRESS_SELECT_GOOGLE_MAPS_API_PLACES_AUTOCOMPLETE_DEBOUNCE_TIME = 300
